<template>
	<div id="statistics-container">
		<div id="graph-wrapper">
			<GraphCard
				v-model="statistics.waiting_time"
				title="TEMPO DE ESPERA"
				:goal="goals.waiting_time"
				type="waiting_time"
				graph-type="circular"
				:reverse="true"
				@change-goal="ChangeGoalHandler"
			/>
			<GraphCard
				v-model="statistics.capacity"
				title="LOTAÇÃO"
				:goal="goals.capacity"
				type="capacity"
				:reverse="true"
				@change-goal="ChangeGoalHandler"
			/>
			<DistributionGraphCard
				v-model="statistics.twenty_four_hours_distribution"
				title="DISTRIBUIÇÃO DE ATENDIMENTO NAS ÚLTIMAS 24H"
				:goal="goals.twenty_four_hours_distribution"
				type="twenty_four_hours_distribution"
				graph-type="distribution"
				:reverse="true"
				@change-goal="ChangeGoalHandler"
			/>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { useConfirmation, useError } from '@/composables'

	import GraphCard from './components/GraphCard.vue'
	import DistributionGraphCard from './components/DistributionGraphCard.vue'

	export default {
		name: 'Statistics',
		components: {
			GraphCard,
			DistributionGraphCard,
		},
		data() {
			return {
				statistics: {
					waiting_time: 0,
					capacity: 0,
					twenty_four_hours_distribution: 0,
				},
				goals: {
					waiting_time: 0,
					capacity: 0,
					twenty_four_hours_distribution: 0,
				},
				requesting: false,
				interval: null,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			ChangeGoalHandler({ key, value }) {
				this.goals[key] = value

				this.SaveGoal(key, value)
			},
			async GetGoals() {
				return window.api
					.call('post', '/reception/get-goals', {
						organization_id: this.requester_selected_id,
					})
					.then(({ status, data }) => {
						if (status !== 200) {
							useError('OCORREU UM ERRO AO BUSCAR AS METAS!')
							return
						}

						this.goals = { ...data.goals }
					})
			},
			async SaveGoal(key, value) {
				return window.api
					.call('post', '/reception/save-goals', {
						organization_id: this.requester_selected_id,
						key,
						value,
					})
					.then(({ status, data }) => {
						if (status !== 200) {
							useError('OCORREU UM ERRO AO DEFINIR A NOVA META!')
							return
						}

						this.goals = { ...data.goals }
						useConfirmation()
					})
			},
			async GetStatistics() {
				if (this.requesting) return

				this.requesting = true

				return window.api
					.call('post', '/reception/get-statistics', {
						organization_id: this.requester_selected_id,
					})
					.then(({ status, data }) => {
						if (status !== 200) {
							useError(
								'OCORREU UM ERRO AO BUSCAR AS ESTATÍSTICAS!'
							)
							return
						}

						for (const [key, value] of Object.entries(
							data.statistics
						)) {
							this.statistics[key] = value.current ?? 0
						}
					})
					.finally(() => {
						this.requesting = false
					})
			},
		},
		async beforeMount() {
			await this.GetGoals()
		},
		mounted() {
			this.GetStatistics()

			// this.interval = setInterval(() => {
			// 	this.GetStatistics()
			// }, 1000 * 60)
		},
		// eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
		beforeDestroy() {
			clearInterval(this.interval)
		},
	}
</script>

<style lang="scss" scoped>
	#statistics-container {
		width: 100%;
		flex-grow: 1;
		background-color: var(--gridBackgroundColor);

		#graph-wrapper {
			width: 100%;
			height: 100%;

			display: grid;
			gap: 0.5rem;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr 1fr;
			grid-template-areas:
				'waiting_time capacity'
				'twenty_four_hours_distribution twenty_four_hours_distribution';

			.capacity {
				grid-area: capacity;
			}
			.waiting_time {
				grid-area: waiting_time;
			}
			.twenty_four_hours_distribution {
				grid-area: twenty_four_hours_distribution;
			}
		}

		// @media (max-width: 900px) {
		// 	#graph-wrapper {
		// 		grid-template-columns: 50% 50%;
		// 		grid-template-rows: 1fr 1fr;
		// 		grid-template-areas:
		// 			'capacity capacity'
		// 			'schedulings_volume waiting_time'
		// 			'waiting_capacity waiting_capacity'
		// 			'no_show production'
		// 			'in_attendance_capacity in_attendance_capacity';
		// 	}
		// }

		// @media (max-width: 560px) {
		// 	#graph-wrapper {
		// 		grid-template-columns: 100%;
		// 		grid-template-rows: 1fr;
		// 		grid-template-areas:
		// 			'capacity'
		// 			'schedulings_volume'
		// 			'waiting_time'
		// 			'waiting_capacity'
		// 			'no_show'
		// 			'production'
		// 			'in_attendance_capacity';
		// 	}
		// }
	}
</style>
